import { repository } from '@woc/woc-repository'
import { Company, CompanyRelation, CompanyUserPermission, ApplicationAccess } from '@/model/company'

export const companyRepository = repository.create({
  entity: 'company',
  url: 'companies',
  allow: 'crule',
  factory: data => new Company(data)
})

export const companyRelationRepository = repository.create({
  entity: 'companyRelation',
  url: 'company-relations',
  allow: 'l',
  factory: data => new CompanyRelation(data)
})

export const companyUserPermissionRepository = repository.create({
  entity: 'companyUserPermission',
  url: 'companies/:companyId/user-permissions',
  allow: 'cdl',
  factory: data => new CompanyUserPermission(data)
})

export const applicationAccessRepository = repository.create({
  entity: 'applicationAccess',
  url: 'application-access',
  allow: 'cdl',
  factory: data => new ApplicationAccess(data)
})

export default repository.asModule(companyRepository, companyRelationRepository, companyUserPermissionRepository, applicationAccessRepository)
